import { apiClient } from './index'
import type { GtfsVehiclePositionResponse } from '../../types/api'

export class VehiclePositionService {
  async getSydneyMetroPositions(): Promise<GtfsVehiclePositionResponse> {
    return apiClient.post<GtfsVehiclePositionResponse>('/nsw_gtfs_positions/sydney-metro/db')
  }

  async getSydneyTrainsPositions(): Promise<GtfsVehiclePositionResponse> {
    return apiClient.post<GtfsVehiclePositionResponse>('/nsw_gtfs_positions/sydney-trains/db')
  }

  async getLightRailInnerwestPositions(): Promise<GtfsVehiclePositionResponse> {
    return apiClient.post<GtfsVehiclePositionResponse>('/nsw_gtfs_positions/light-rail-innerwest/db')
  }

  async getSydneyMetroLivePositions(): Promise<GtfsVehiclePositionResponse> {
    return apiClient.get<GtfsVehiclePositionResponse>('/nsw_gtfs_positions/sydney-metro')
  }

  async getSydneyTrainsLivePositions(): Promise<GtfsVehiclePositionResponse> {
    return apiClient.get<GtfsVehiclePositionResponse>('/nsw_gtfs_positions/sydney-trains')
  }

  async getLightRailInnerwestLivePositions(): Promise<GtfsVehiclePositionResponse> {
    return apiClient.get<GtfsVehiclePositionResponse>('/nsw_gtfs_positions/light-rail-innerwest')
  }
}

export const vehiclePositionService = new VehiclePositionService()
